import { render, staticRenderFns } from "./clueRecycleBin.vue?vue&type=template&id=077596fe&scoped=true"
import script from "./clueRecycleBin.vue?vue&type=script&lang=js"
export * from "./clueRecycleBin.vue?vue&type=script&lang=js"
import style0 from "./clueRecycleBin.vue?vue&type=style&index=0&id=077596fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077596fe",
  null
  
)

export default component.exports